<template>
  <div>
       <a-modal class="" title="创建预算计划" :visible="planeVisible"  @cancel="closeModel" width="40%">
           <template slot="footer">
				<a-button key="back" @click="closeModel"> 取消 </a-button>
				<a-button key="submit" type="primary" @click="addApply"> 创建预算 </a-button>
			</template>
           <!-- 预算基础信息 -->
           	<a-form-model :model="baseInform" ref="baseInform">
				<a-row class="formSpan"><span class="box"></span> 预算基础信息</a-row>
				<a-row class="formItem">
					<a-form-model-item  prop="budget_name" label="预算计划名称" :rules="{
                        required: true,
                        message: '请输入此预算计划名称',
                        trigger: 'blur',
                    }">
                        <!-- <div><span class="fontColor">*</span>预算计划名称</div> -->
                        <a-input v-model="baseInform.budget_name"  placeholder="请输入此预算计划名称" />
					</a-form-model-item>
				</a-row>
                <a-row class="formItem">
					<a-form-model-item  prop="start_year" label="财年开始年度" :rules="{
                        required: true,
                        message: '请选择财年开始年度',
                        trigger: 'blur',
                    }">
                        <!-- <div><span class="fontColor">*</span>财年开始年度</div> -->
                        <!-- <a-input v-model="baseInform.start_year"  placeholder="请输入此预算计划名称" /> -->
                         <a-select allowClear  placeholder="请选择财年开始年度" v-model="baseInform.start_year"  style="width:100%" >
                            <a-select-option :value="item" v-for="(item, index) in yearList" :key="index">{{ item }}
                            </a-select-option>
                        </a-select>
                        
					</a-form-model-item>
				</a-row>
                <a-row class="formItem">
					<a-form-model-item  prop="budget_circle" label="预算周期" :rules="{
                        required: true,
                        message: '请选择预算周期',
                        trigger: 'blur',
                    }">
                        <!-- <div><span class="fontColor">*</span>预算周期</div> -->
                        <a-select allowClear  placeholder="请选择状态" v-model="baseInform.budget_circle"  style="width:100%" disabled>
                            <a-select-option :value="item.title" v-for="(item, index) in dateList" :key="index">{{ item.title }}
                            </a-select-option>
                        </a-select>
					</a-form-model-item>
				</a-row>
                <a-row class="formSpan"><span class="box"></span> 预算规则设置</a-row>
                <a-row>
                    <div class="containerBox">
                        <span>预算周期转结</span>
                        <div>  <a-switch default-checked v-model="baseInform.is_cumulative"  style="margin-right: 10px;"/>打开开关后，当期末未用完的预算自动累计到下期</div>
                    </div>
                    <div class="containerBox">
                        <span>当预算超额时</span>
                        <div>
                            <a-radio-group v-model="baseInform.overhead_method"  >
                                <a-radio v-for="(item, index) in prohibitList" :key="index" :value="item.id">
                                    {{item.title}}
                                </a-radio>
                            </a-radio-group>
                        </div>
                    </div>
                </a-row>
                <a-row class="formSpan space"><span class="box"></span> 预算维度</a-row>
                <a-row class="formItem">
					<a-form-model-item  prop="budget_dimension" label="预算维度" :rules="{
                        required: true,
                        message: '请输入此预算计划名称',
                        trigger: 'blur',
                    }">
                        <!-- <div><span class="fontColor">*</span>预算维度</div> -->
                        <a-select allowClear  placeholder="请选择预算维度" v-model="baseInform.budget_dimension"   style="width:100%" disabled>
                            <a-select-option :value="item.title" v-for="(item, index) in budgetList" :key="index">{{ item.title }}
                            </a-select-option>
                        </a-select>
					</a-form-model-item>
				</a-row>
                <a-row class="formItem">
					<a-form-model-item  prop="child_budget_dimension" label="子集预算维度" :rules="{
                        required: true,
                        message: '请选择子集预算维度',
                        trigger: 'blur',
                    }">
                        <!-- <div><span class="fontColor">*</span>子集预算维度</div> -->
                        <a-select allowClear  placeholder="请选择子集预算维度" v-model="baseInform.child_budget_dimension"   style="width:100%" >
                            <a-select-option :value="item.title" v-for="(item, index) in subBudgetList" :key="index">{{ item.title }}
                            </a-select-option>
                        </a-select>
					</a-form-model-item>
				</a-row>
                <a-row style="display: flex; justify-content: center; align-items: center;">
                    <div class="view">
                        <!-- <div class="ico">
                            <a-icon class="circle" type="notification" />
                        </div> -->
                        <div class="hiteBox">
                            <div style="color:#409EFF;">
                                <a-icon type="notification" />
                               <span class="hb">温馨提示</span> 
                            </div>
                            <div class="hite">当前设置内容为全年预算底层信息，创建后底层规则无法进行修改</div>
                        </div>
                    </div>
                     
                </a-row>
                
            </a-form-model>

       </a-modal>
       
      
  </div>
</template>

<script>
import { postApply } from '@/api/budget'
export default {
   components: {
    },
   data() {
    return {
        planeVisible: false,
        baseInform: {
            budget_name: '',//预算计划名称
            child_budget_dimension: undefined,
            budget_dimension: '基于组织架构进行预算',
            overhead_method: 1,
            is_cumulative: true,
            budget_circle: '每月',
            start_year: undefined,// "开始年度"
        },
        dateList: [{
            id: 1,
            title: '每月'
        }],
        prohibitList: [{
            id: 1,
            title: '禁止单据提交'
        }],
        budgetList: [{
            id: 1,
            title: '基于组织架构进行预算'
        }],
        subBudgetList: [{
            id: 1,
            title: '各单据模板（费用类型）'
        },
        // {
        //     id: 2,
        //     title: '各单据模板（费用类型）+明细类型'
        // },
        // {
        //     id: 3,
        //     title: '业务线'
        // }
        ],
        prohibit: 1,
        yearList: [],
      
    }
  },
  methods: {
    //   打开弹窗
    init() {
        this.yearList = []
        //获取当前年份
        var date = new Date();
        var year = date.getFullYear(); 
        for(var i=0;i<3;i++) {
            this.yearList.push(year)
            year++
        }

        this.planeVisible = true
    },
    // 关闭弹窗
    closeModel() {
        this.planeVisible = false
        this.$refs.baseInform.resetFields()
        this.baseInform = {
            budget_name: '',//预算计划名称
            child_budget_dimension: undefined,
            budget_dimension: '基于组织架构进行预算',
            overhead_method: 1,
            is_cumulative: true,
            budget_circle: '每月',
            start_year: undefined,// "开始年度"
        }
    },
    addApply() {
        if(this.baseInform.start_year) {
           this.baseInform.start_year = this.baseInform.start_year.toString()
        }
        console.log(this.baseInform , 'baseInform=========================')
        this.$refs.baseInform.validate((valid) => {
            if(valid) {
                postApply(this.baseInform).then(res => {
                    if(res.code == 200) {
                        this.planeVisible = false
                        this.$emit('changeData')
                        this.baseInform = {
                            budget_name: '',//预算计划名称
                            child_budget_dimension: undefined,
                            budget_dimension: '基于组织架构进行预算',
                            overhead_method: 1,
                            is_cumulative: true,
                            budget_circle: '每月',
                            start_year: undefined,// "开始年度"
                        },
                        this.$message.success(res.msg)
                    }
                })

            }
        })

    }
  }

}
</script>

<style lang="less" scoped>
.formSpan {
    font-weight: 700;
    color: black;
    font-size: 18px;
    display: flex;
    .box {
        align-items: center;
        display: inline-block;
        height: 27px;
        width: 10px;
        margin-right: 5px;
        background-color: #1890ff;
    }
}
.fontColor {
    color: red;
}
.formItem {
    padding: 0;
    width: 70%;
}
.containerBox {
    display: flex;
    justify-content: space-between;
	align-items: center;
    padding: 10px 0 0 15px;
    span {
        width: 30%;

    }
    div {
       width: 70%

    }
}
.space {
    margin-top: 10px;
}
.view {
    width: 80%;
    border: 1px solid #409EFF;
    padding: 20px 50px 20px 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #d9ecff;
    border-radius: 4px;
    color: #409EFF;

    .ico {
      width: 45px;
      height: 40px;
      float: left;
      display: flex;
      justify-content: center;
      align-items: center;

      .circle {
        font-size: 22px;
        color: #409EFF;
      }
    }

    .hiteBox {
      color: rgb(32, 31, 31);
      width: calc(100% - 45px);
      float: left;
      .hite {
          margin-left: 17px;

      }
      .hb {
        color: rgb(32, 31, 31);
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 3px;
        margin-left: 5px;

      }

    }

  }

</style>